const logEvent = (name, options) => {
  if (typeof amplitude !== 'undefined') {
    amplitude.getInstance().logEvent(name, options);
  }
};

export default logEvent;
